




























































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import QRCode from 'qrcode-generator'
import { MedicalBusiness, Clinic } from '@/interface/api'

@Component({
  name: 'TreatmentReservationCompletePage'
})
export default class TreatmentReservationCompletePage extends Vue {
  @Prop({ default: '' }) private medicalBusinessId!: string
  @Prop({ default: '' }) private medicalCustomerId!: string
  @Prop({ default: '' }) private sessionKey!: string
  @Prop({ default: () => null }) private medicalbusiness!: MedicalBusiness
  @Prop({ default: false }) private isAppPlan!: boolean
  @Prop({ default: false }) private targetClinic!: Clinic

  private qrCodeUrl = ''

  @Watch('targetClinic', { immediate: true })
  onTargetClinicChange() {
    if (!this.targetClinic?.line_app_url) return
    const qr = QRCode(4, 'L')
    qr.addData(this.targetClinic.line_app_url)
    qr.make()
    this.qrCodeUrl = qr.createDataURL()
  }

  lineLink() {
    const url =
      'https://liff.line.me/' +
      this.targetClinic.liff_id +
      '/web-first-reservation-redirect/?medicalCustomerId=' +
      this.medicalCustomerId +
      '&sessionKey=' +
      this.sessionKey
    window.open(url, '_blank')
  }
}
